import { render, staticRenderFns } from "./GroupSchedules.vue?vue&type=template&id=ec6050b6&"
import script from "./GroupSchedules.vue?vue&type=script&lang=js&"
export * from "./GroupSchedules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports